import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faExclamation,
  faAngleLeft,
  faAngleRight,
  faCircleNotch,
} from '@fortawesome/free-solid-svg-icons';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

library.add(faCheck, faExclamation, faAngleLeft, faAngleRight, faCircleNotch);

createApp(App)
  .use(router)
  .component('fa', FontAwesomeIcon)
  .component('PulseLoader', PulseLoader)
  .mount('#price-indicator');
